import LandmarkHelper from '@core/scripts/helper/landmark-helper';
import Landmark from '@core/scripts/components/landmark-adapter';
import WindowManager from '@core/scripts/components/window-manager';

function createAndSendSlideClickedLandmark(sliderType,
                                           productImageId,
                                           itemNumber,
                                           productDigistyleId,
                                           availabilityStatus,
                                           landmarkData,
                                           isProductCardSlider) {
    if(landmarkData) {
        const {pageType, pointOfSaleId, shopId} = landmarkData;
        const type = isProductCardSlider ? landmarkData.landmarkType : landmarkData.type;
        const clickLandmark = LandmarkHelper.createLandmarkDataString({
            recommendationType: `${pageType}_${sliderType}`,
            pointOfSaleId: pointOfSaleId,
            shopId: shopId,
            productImageId: productImageId,
            productSummaryItemId: itemNumber,
            productDigistyleId: productDigistyleId
        });

        if (availabilityStatus === 'SOLDOUT') {
            Landmark.sendLandmark({
                landmark: "userinterface",
                click: clickLandmark,
                click_na: itemNumber + "\\" + productDigistyleId
            });
        } else {
            Landmark.sendClickLandmark(clickLandmark);
        }

        Landmark.sendCarouselLandmark({
            clickpage: `${pageType}\\${shopId}`,
            clickoverview: `${pointOfSaleId}\\${type}\\${productImageId}`,
            clickitem: `${itemNumber}`
        });
        WindowManager.setSpecificTabDataItem("pointOfSaleId", landmarkData.pointOfSaleId);
    }
}

function createAndSendSliderBulletClickedLandmark(bulletIndex, landmarkData) {
    if(bulletIndex !== null && landmarkData) {
        Landmark.sendCarouselLandmark({
            clickpage: `${landmarkData.pageType}\\${landmarkData.shopId}`,
            clickoverview: `${landmarkData.pointOfSaleId}\\${landmarkData.type}`,
            clickitem: `scrolling_${bulletIndex}`
        });
    }
}

function createAndSendSliderVisibilityLandmark(sliderType, event, landmarkData, isProductCardSlider) {
    const itemNumbers = event.items
        .slice(0, event.displayedItemCount)
        .map((item, index) => `${index + 1}:${isProductCardSlider ? item.articleNumber : item.itemNumber}`)
        .join('\\');
    if(sliderType && itemNumbers && landmarkData) {
        const type = isProductCardSlider ? landmarkData.landmarkType : landmarkData.type;
        const landmark = LandmarkHelper.createLandmarkDataString({
            recommendationType: `${landmarkData.pageType}_${sliderType}`,
            pointOfSaleId: landmarkData.pointOfSaleId,
            landmarkType: type,
            itemNumbers
        });

        Landmark.sendLandmark({
            "landmark": "action",
            "visible": landmark
        });
    }
}

function createSendSlideChangedLandmark(landmarkData, isProductCardSlider) {
    if(landmarkData) {
        const type = isProductCardSlider ? landmarkData.landmarkType : landmarkData.type;
        Landmark.sendCarouselLandmark({
            clickpage: `${landmarkData.pageType}\\${landmarkData.shopId}`,
            clickoverview: `${landmarkData.pointOfSaleId}\\${type}`,
            clickitem: 'slide'
        });
    }
}

function createAndSendOutfitVisibilityLandmark(sliderType, outfit, itemNumbers, landmarkData) {
    const {pageType, pointOfSaleId, type, originItemNumber} = landmarkData;
    const {assetId} = outfit;
    const landmark = LandmarkHelper.createLandmarkDataString({
        recommendationType: `${pageType}_${sliderType}`,
        pointOfSaleId: pointOfSaleId,
        landmarkType: type,
        assetId,
        itemNumbers,
        originItemNumber: `stl_artikel_${originItemNumber}`
    });

    Landmark.sendLandmark({
        "landmark": "action",
        "visible": landmark
    });
}

function createAndSendOutfitItemClickedLandmark(sliderType, clickedItem, landmarkData) {
    if(!landmarkData || !clickedItem) {
        return;
    }

    const {pageType, pointOfSaleId, shopId, type, originItemNumber} = landmarkData;
    const {assetId, itemNumber, productDigistyleId, outfitAssetId} = clickedItem;
    const clickLandmark = LandmarkHelper.createLandmarkDataString({
        recommendationType: `${pageType}_${sliderType}`,
        pointOfSaleId,
        shopId,
        assetId,
        itemNumber,
        productDigistyleId,
        outfitAssetId,
        originItemNumber: `stl_artikel_${originItemNumber}`
    });

    Landmark.sendClickLandmark(clickLandmark);
    Landmark.sendCarouselLandmark({
        clickpage: `${pageType}\\${shopId}`,
        clickoverview: `${pointOfSaleId}\\${type}\\${assetId}`,
        clickitem: `${itemNumber}`
    });
    WindowManager.setSpecificTabDataItem("pointOfSaleId", landmarkData.pointOfSaleId);
}

function createAndSendOutfitItemProductCardClickedLandmark(sliderType, clickedItem, landmarkData, outfitAssetId) {
    if(!landmarkData || !clickedItem) {
        return;
    }

    const {pageType, pointOfSaleId, shopId, type, originItemNumber} = landmarkData;
    const {assetId, articleNumber: itemNumber, digistyleId: productDigistyleId} = clickedItem;
    const clickLandmark = LandmarkHelper.createLandmarkDataString({
        recommendationType: `${pageType}_${sliderType}`,
        pointOfSaleId,
        shopId,
        assetId,
        itemNumber,
        productDigistyleId,
        outfitAssetId,
        originItemNumber: `stl_artikel_${originItemNumber}`
    });

    Landmark.sendClickLandmark(clickLandmark);
    Landmark.sendCarouselLandmark({
        clickpage: `${pageType}\\${shopId}`,
        clickoverview: `${pointOfSaleId}\\${type}\\${assetId}`,
        clickitem: `${itemNumber}`
    });
    WindowManager.setSpecificTabDataItem("pointOfSaleId", landmarkData.pointOfSaleId);
}

export default {
    createSendSlideChangedLandmark,
    createAndSendSlideClickedLandmark,
    createAndSendSliderVisibilityLandmark,
    createAndSendSliderBulletClickedLandmark,
    createAndSendOutfitVisibilityLandmark,
    createAndSendOutfitItemClickedLandmark,
    createAndSendOutfitItemProductCardClickedLandmark
}
